<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="addGoods" style="float:right;margin:10px 15px 10px 0;"></el-button>
    <el-table ref="list" border :data="tableData" style="width: 100%" @row-click="rowClick">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <!-- <el-table-column prop="GoodsName" label="商品名称" /> -->
      <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
      <template slot-scope="{row}">
        <account-select
          v-model="row.GoodsName"
          :source="DAccount"
          @select="onSelect($event,row)"
        />
      </template>
      </el-table-column>
      <el-table-column prop="Model" label="规格" />
      <el-table-column prop="UnitName" label="单位" />
      <el-table-column prop="Quantity" label="数量">
        <template slot-scope="{ row }">
          <el-input v-model="row.Quantity" type="number" @input="changeNum(row)"></el-input>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="InventoryQuantity" label="账面数量">
        <template slot-scope="{ row }">
          <el-input v-model="row.InventoryQuantity" type="number"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="DiffQuantity" label="盈亏数量">
        <template slot-scope="{ row }">
          <el-input v-model="row.DiffQuantity" type="number"></el-input>
        </template>
      </el-table-column> -->
      <el-table-column prop="Price" label="调出价格" />
      <el-table-column prop="Amount" label="调出金额" />
      <el-table-column prop="AvailableQuantity" label="可用数量" />
      <el-table-column label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-link icon="el-icon-copy-document" style="margin-right:10px;" @click="copy(scope.row,scope.$index)" :underline="false">复制</el-link>
          <el-link icon="el-icon-delete" @click="del(scope.row,scope.$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsDialog from "@/components/sales/business/listDialog";
import accountSelect from "@/components/sales/business/select";
export default {
  props: {
    info: {},
  },
  components: {
    goodsDialog,
    accountSelect
  },
  data() {
    return {
      tableData: [],
      tableDel: [],
      DAccount: [],
      sApi: require("@/api/sale/sales").default,
      api: require("@/api/stock/inventory").default,
      account_api: require("@/api/goods/goods").default,
    };
  },
  mounted() {
    this.account_api.list({ Status: 1 }).then((res) => {
      if (res.Code == 0) this.DAccount = res.Data;
    });
  },
  methods: {
    rowClick(row) {
      var index = this.$refs.list.data.indexOf(row);
      if (index + 1 == this.$refs.list.data.length) {
        // 
        this.addGoods();
      }
    },
        onSelect(e, row) {
          
          // this.setGoods(e,row)
      row.T = row.T == 0 ? 0 : 1;
      // row.AccountId = e.AccountId;
      // row.GoodsName = e.GoodsName;
          row.OrderGoodsId= 0
          row.DocId= this.info.DocId || 0
          row.BarCode= e.BarCode
          row.GoodsName= e.GoodsName
          row.GoodsId= e.GoodsId
          row.Model= e.Model || ""
          row.UnitId= e.UnitId || 0
          row.UnitName= e.MainUnitName || ""
          row.Quantity= 0
          row.BatchNo= e.BatchNo || ""
          row.Offer= e.WholesalePrice || 0
          row.Discount= 100
          row.Price=e.WholesalePrice || 0
          row.ExistQuantity= e.ExistQuantity || 0
          row.AvailableQuantity= e.AvailableQuantity || 0
          row.TaxRate= 0
          row.TaxAmount= 0
          row.Amount= 0
          row.NoTaxAmount= 0
          row.PromotionType= 0
          row.PromotionId= 0
          row.ReferenceCost= e.ReferenceCost || 0
          row.GrossProfit= 0
          row.Remark= e.Remark || ""
          row.Thumbnail= ""
          row.OutQuantity= 0
          row.AddTime= this.info.DocDate || today
          row.InventoryQuantity= e.AvailableQuantity || 0
          row.DiffQuantity= e.DiffQuantity || 0
        
    },
    getData() {
      if(this.info.DocId != 0 && this.tableData.length > 0) {
        this.tableData.forEach(item => {
          if(item.T) {
            this.tableDel.push(item)
          }
        })
      }
      this.tableData = []
      this.sApi.getGoodsList(this.info.OrderId).then((res) => {
        res.Data.forEach(e => {
          this.tableData.push({
            T: 0,
            DocGoodsId: 0,
            DocId: this.info.DocId,
            BarCode: e.BarCode || "",
            GoodsId: e.GoodsId || 0,
            GoodsName: e.GoodsName || "",
            Model: e.Model || "",
            UnitId: e.UnitId || 0,
            UnitName: e.UnitName || "",
            Quantity: e.Quantity || 0,
            Amount: e.Amount || 0,
            BatchNo: e.BatchNo || "",
            Offer: e.Offer || 0,
            Remark: e.Remark || "",
            ReferenceCost: e.ReferenceCost || 0,
            Thumbnail: e.Thumbnail || "",
            AddTime: e.AddTime || "",
            Price: e.WholesalePrice || 0,
            AvailableQuantity: e.AvailableQuantity || 0,
          })
        });
      });
    },
    del(row,index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if(!row.T&&row.T!==0) {
            row.T = 2
            this.tableDel.push(row)
          }
          this.tableData.splice(index,1)
        })
    },
    copy(row,index) {
      this.tableData.splice(index+1,0,{
        ...row,
        T: 0,
        DocGoodsId: 0
      })
    },
    changeNum(row) {
      if(row.T !== 0) {
        row.T = 1
      }
      // row.Quantity = Math.floor(row.Quantity)
      row.Amount = ((row.Quantity * row.Price) * 100 / 100).toFixed(2)
    },
    addGoods(e) {
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1 });
      // });
       let goods = {
          T: 0,
          OrderGoodsId: 0,
          DocId: 0,
          BarCode: "",
          GoodsName: "",
          GoodsId:"",
          Model:"",
          UnitId: 0,
          UnitName:"",
          Quantity: 0,
          BatchNo:"",
          Offer:  0,
          Discount: 100,
          Price: 0,
          ExistQuantity:  0,
          AvailableQuantity:  0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost:  0,
          GrossProfit: 0,
          Remark: "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: "",
          InventoryQuantity:  0,
          DiffQuantity:0,
        }
        this.tableData.push(goods)
    },
    setGoods(e) {
      
      this.tableData.push({
        T: 0,
        DocGoodsId: 0,
        DocId: this.info.DocId,
        BarCode: e.BarCode || "",
        GoodsId: e.GoodsId || 0,
        GoodsName: e.GoodsName || "",
        Model: e.Model || "",
        UnitId: e.MainUnitId || 0,
        UnitName: e.MainUnitName || "",
        Quantity: e.Quantity || 0,
        Amount: e.Amount || 0,
        BatchNo: e.BatchNo || "",
        Offer: e.Offer || 0,
        ReferenceCost: e.ReferenceCost || 0,
        Remark: e.Remark || "",
        Thumbnail: e.Thumbnail || "",
        AddTime: this.info.DocDate || "",
        Price: e.WholesalePrice || 0,
        AvailableQuantity: e.AvailableQuantity || 0,
      })
    }
  },
};
</script>

<style>
.el-link{
  font-size: 14px;
}
input::-webkit-outer-spin-button,

input::-webkit-inner-spin-button { -webkit-appearance: none; }

input[type="number"]{ -moz-appearance: textfield; }
</style>